var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOopsWarningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svg3687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1680_1716",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 59
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath3701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3699",
    d: "M0 3.8147e-06H59V59H0V3.8147e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1680_1716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3705",
    d: "M12.2148 57.2715H46.7852",
    stroke: "#654CEB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3709",
    d: "M46.7852 36.2988H12.2148V8.64258C12.2148 4.82406 15.3104 1.72852 19.1289 1.72852H39.8711C43.6896 1.72852 46.7852 4.82406 46.7852 8.64258V36.2988Z",
    stroke: "#654CEB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3713",
    d: "M26.043 8.64258L32.957 15.5566",
    stroke: "#654CEB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3717",
    d: "M26.043 15.5566L32.957 8.64258",
    stroke: "#654CEB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3721",
    d: "M15.6719 50.3574V36.2988",
    stroke: "#654CEB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3725",
    d: "M43.3281 36.2988V50.3574",
    stroke: "#654CEB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3729",
    d: "M12.2148 50.3574H46.7852",
    stroke: "#654CEB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3733",
    d: "M19.1289 22.4707H39.8711",
    stroke: "#654CEB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3737",
    d: "M36.4141 29.3848H22.5859",
    stroke: "#654CEB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOopsWarningIcon);
export default __webpack_public_path__ + "static/media/oops-warning-icon.e9cc64f443c5ff8e0295534a12be0e51.svg";
export { ForwardRef as ReactComponent };